import type { Routes } from '@angular/router';

import { AGGREGATED_REVIEWS_ROUTES } from '#modules/reviews/routes/aggregated-reviews.routing';

export const AGGREGATED_REPUTATION_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-reputation-layout/aggregated-reputation-layout.component').then(
                (m) => m.AggregatedReputationLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'reviews',
            },
            {
                path: 'reviews',
                loadChildren: () => AGGREGATED_REVIEWS_ROUTES,
            },
        ],
    },
];
